import { Type } from "@angular/core";
import { MatSortable } from "@angular/material/sort";
import { ICommand } from "../commands/i-command";
import { IApiService } from "./api/i-api-service";
import { ICol } from "./columns/i-col";
import { ICellComponent } from "./i-cell-component";

/** A single filter-button option. A bare string is shorthand for an option
 * whose display label and payload value are identical. The object form lets
 * the displayed label (e.g. "Suspicious") differ from the value sent to the
 * backend (e.g. "SUSPICIOUS"). */
export type TableFilterOption = string | { label: string; value: string };

export interface TableFilter {
  /** Key used to track this filter's selected option in the button bar. */
  filterBy: string;
  /** Optional i18n key for the bar's header. Falls back to "Filter By {filterBy}:". */
  label?: string;
  options: TableFilterOption[];
  /** When set, clicking a button emits `{ searchBy: searchColumn, searchFor: value }`
   * instead of the default `{ [filterBy]: value }`. */
  searchColumn?: string;
}

export class TableStructure<T extends object> {
  questionCode?: string;
  questionColumnsAnchor?: string;
  constructor(
    public cols: ICol<T, Type<ICellComponent<T>>>[],
    //public actions: TableAction<T>[],
    public type: "clientSide" | "serverSide",
    public pageSizes: number[] = [10, 15, 20],
    public sortBy?: MatSortable,
    public hasColsSelector?: boolean,
    public actions?: ICommand<T, IApiService<T>>[],
    public filters?: TableFilter[],
    public disableSort? : Boolean
  ) {}
}
